<template>
    <RecruitViewPage :data="data" />
</template>

<script>
import { getPostDetail } from '@/api';
import RecruitViewPage from '@/views/common/RecruitViewPage.vue';

export default {
    components: {
        RecruitViewPage,
    },
    data() {
        return {
            data: null,
        };
    },
    methods: {
        async getData() {
            console.log('getDetail')
            try {
                const [recruitDetail, noticeDetail] = await Promise.all([
                    getPostDetail('/recruit/detail', this.$route.params.id, this.$route.query),
                    getPostDetail('/recruit/notice/detail', this.$route.params.id, this.$route.query),
                ]);

                if (!recruitDetail.data && !noticeDetail.data) {
                    const targetRoute = this.$route.path.split('/').slice(0, -1).join('/');
                    this.$router.push({
                        path: targetRoute,
                        query: {
                            ...this.$route.query,
                        },
                    });
                } else {
                    this.data = {
                        recruit: recruitDetail.data || {},
                        notice: noticeDetail.data || {},
                    };
                }
            } catch (error) {
                console.log(error);
            }
        },
    },
    async mounted() {
        this.getData();
    },
    watch: {
        async $route() {
            this.getData();
        },
    },
};
</script>
